import type { Session } from '@/types';

// Per-session capability predicates used by the SessionCard menu variants.
// A native Moments Appointment adapted through `appointmentActionSession`
// carries authoritative booleans on `sourceAppointmentCancelAllowed` and
// `sourceAppointmentRescheduleAllowed`; legacy Cal sessions leave the
// fields undefined. In both cases, "explicitly denied" (===false) is the
// only reason to hide the menu item — undefined preserves the pre-native
// behavior of showing the action.
//
// Centralised so `Menu/Upcoming.tsx` and `Menu/Next.tsx` share one rule.
// A capability added here reaches both menu variants automatically.

export const canCancelSession = (session: Session): boolean =>
  session.sourceAppointmentCancelAllowed !== false;

export const canRescheduleSession = (session: Session): boolean =>
  session.sourceAppointmentRescheduleAllowed !== false;
